/**
 * Limity maks. uczestników wydarzenia:
 * - konto standardowe: 4, 6, 8
 * - rola organizator / moderator / admin LUB is_premium (VIP): dodatkowo 10–20 co 2
 */

export const MAX_PARTICIPANTS_ALL = [4, 6, 8, 10, 12, 14, 16, 18, 20];

export const MAX_PARTICIPANTS_STANDARD_TIER = [4, 6, 8];

export const MAX_PARTICIPANTS_EXTENDED_ONLY = [10, 12, 14, 16, 18, 20];

const EXTENDED_ROLES = new Set(['organizator', 'moderator', 'admin']);

/**
 * @param {{ userRole?: string | null, isPremium?: boolean | null }} tier
 * @returns {boolean}
 */
export function userCanUseExtendedMaxParticipantsCap(tier) {
  const role = tier?.userRole || 'user';
  if (EXTENDED_ROLES.has(role)) return true;
  return tier?.isPremium === true;
}

/**
 * @param {number} value
 * @param {boolean} extendedCap
 * @returns {boolean}
 */
export function isAllowedMaxParticipants(value, extendedCap) {
  const n = Number(value);
  if (!Number.isInteger(n) || !MAX_PARTICIPANTS_ALL.includes(n)) return false;
  if (n <= 8) return true;
  return extendedCap === true;
}

/**
 * @param {string | number} current
 * @param {boolean} extendedCap
 * @returns {string}
 */
export function clampMaxParticipantsToTier(current, extendedCap) {
  const n = parseInt(String(current), 10);
  if (!Number.isFinite(n) || !MAX_PARTICIPANTS_ALL.includes(n)) return '4';
  if (!extendedCap && n > 8) return '8';
  return String(n);
}
